import React, { useEffect, useRef } from 'react';
// @ts-ignore
import OktaSignIn from '@okta/okta-signin-widget';
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';

interface Props {
  config?: any;
  onSuccess?: any;
  onError?: any;
}

const OktaWidget = ({ config, onSuccess, onError }: Props): React.ReactElement => {
  const widgetRef: any = useRef();
  useEffect((): any => {
    if (!widgetRef.current) return false;

    const widget = new OktaSignIn(config);

    widget
      .showSignInToGetTokens({
        el: widgetRef.current
      })
      .then(onSuccess)
      .catch(onError);

    return () => widget.remove();
  }, []);

  return (
    <div className={`w-full h-screen`}>
      <div ref={widgetRef} className={`w-full h-full relative z-10 justify-center items-center flex`}></div>
      <div className="fixed top-0 left-0 w-full h-full bg-gradient-to-r from-[#003399] to-[#33CCCC]" />
    </div>
  );
};

export default OktaWidget;
